import { useEffect, useState } from "react";
import makeAnimated from "react-select/animated";
import AsyncSelect from "react-select/async";
import useGetHook from "../../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const animatedComponents = makeAnimated();

const MultipleSelectField = (props: any) => {
  const {
    watch,
    register,
    setValue,
    label,
    queryKey,
    clearErrors,
    url,
    value,
    errors,
    props: otherProps,
  } = props;
  const limit = 10;
  const [query, setQuery] = useState("");
  const { data: serverData } = useGetHook({
    queryKey: [queryKey, `${queryKey}-${limit}-${query}`],
    url: url,
    params: {
      limit: limit,
      offset: 0,
      search: query,
      ...otherProps,
    },
  });
  const [defaultValue, setDefaultValue] = useState(
    [...value]
  );

  const onChange = (value: any) => {
    setValue(register?.name, value?.map((items: any) => items?.value) ?? []);
    setDefaultValue(value);
    clearErrors();
  };

  const loadOptions = (
    inputValue: string,
    callback: (options: any) => void
  ) => {
    setQuery(inputValue?.length == 1 ? "" : inputValue);
    setTimeout(() => {
      callback(
        serverData?.results?.map((item: any, index: number) => ({
          label: item?.name,
          value: item?.id,
        }))
      );
    }, 1000);
  };


  return (
    <div className={tw`mt-4`}>
      <label htmlFor="">{label}</label>
      <AsyncSelect
        defaultValue={defaultValue}
        loadOptions={loadOptions}
        components={animatedComponents}
        closeMenuOnSelect={false}
        onChange={onChange}
        isMulti
        defaultOptions={
          serverData?.results?.map((item: any, index: number) => ({
            label: item?.name,
            value: item?.id,
          })) ?? []
        }
      />
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors?.vendors}</p>
      )}
    </div>
  );
};

export default MultipleSelectField;
